import React from 'react';
import { Link } from 'react-router-dom';

const DeleteModal = ({ id, image }) => {
  return (
    <div id={id} className="modal fade delete-modal" role="dialog">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center">
            <img src={image} alt="#" width={50} height={46} />
            <h3>Are you sure want to delete this?</h3>
            <div className="m-t-20">
              <Link to="#" className="btn btn-white me-2" data-bs-dismiss="modal">
                Close
              </Link>
              <button type="submit" className="btn btn-danger">
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;